import { colors } from '../theme'

export const overviewTabsSx = {
  marginBottom: 2,
  paddingX: { xs: 1.5, sm: 2.5 },
  borderBottom: '1px solid #ECEFF5',
  '& .MuiTabs-indicator': {
    backgroundColor: '#FCB402',
    height: 3,
    borderRadius: '999px 999px 0 0',
  },
}

export const overviewTabSx = {
  textTransform: 'none',
  minHeight: 46,
  minWidth: 'fit-content',
  paddingX: 0,
  paddingY: 1.5,
  marginRight: 3,
  color: '#8A90A4',
  fontSize: 14,
  fontWeight: 600,
  '&.Mui-selected': {
    color: colors.cello,
    fontWeight: 700,
  },
}

export const overviewActionButtonSx = {
  textTransform: 'none',
  borderRadius: '999px',
  paddingX: 2,
  paddingY: 1,
  borderColor: '#D7DDEA',
  color: colors.cello,
  backgroundColor: 'white',
  fontWeight: 700,
  boxShadow: 'none',
  '&:hover': {
    borderColor: '#C8D0E0',
    backgroundColor: '#F8F9FC',
    boxShadow: 'none',
  },
}

export const overviewFilterCountBadgeSx = {
  minWidth: 16,
  height: 16,
  borderRadius: '999px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingX: 0.4,
  backgroundColor: colors.cello,
  color: 'white',
  // Keep the badge readable but visually lighter than the surrounding CTA label.
  fontSize: 9,
  fontWeight: 400,
  lineHeight: 1,
}

export const overviewResetFiltersSx = {
  textTransform: 'none',
  width: 52,
  minWidth: 52,
  paddingX: 0.2,
  paddingY: 0.25,
  color: '#7A8197',
  fontWeight: 700,
  fontSize: 12,
  lineHeight: 1.05,
  textAlign: 'right',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  '&:hover': {
    backgroundColor: 'transparent',
    color: colors.cello,
    textDecoration: 'underline',
  },
}

export const overviewSearchFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 3,
    backgroundColor: 'white',
  },
}
